@use "../../styles/breakpoint.module.scss" as *;

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    composes: listReset from "../../styles/composable/utility.module.css";

    --labui-grid-gap: var(--spacer-56) var(--default-grid-gap);

    @media ($below-mobile) {
        --labui-grid-gap: var(--spacer-80);
    }
}
